// Turn every \" to "
export default function normalizeEscapedString(text: string) {
  return text.replaceAll('\\"', '"')
}
